/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengeRegisterResponse
 */
export interface ChallengeRegisterResponse {
    /**
     * 
     * @type {string}
     * @memberof ChallengeRegisterResponse
     */
    membershipId: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeRegisterResponse
     */
    acceptedTermsAt: number;
    /**
     * True if a Realm UUID was attached to the User record during this call.
     * @type {boolean}
     * @memberof ChallengeRegisterResponse
     */
    realmLinked: boolean;
}

/**
 * Check if a given object implements the ChallengeRegisterResponse interface.
 */
export function instanceOfChallengeRegisterResponse(value: object): value is ChallengeRegisterResponse {
    if (!('membershipId' in value) || value['membershipId'] === undefined) return false;
    if (!('acceptedTermsAt' in value) || value['acceptedTermsAt'] === undefined) return false;
    if (!('realmLinked' in value) || value['realmLinked'] === undefined) return false;
    return true;
}

export function ChallengeRegisterResponseFromJSON(json: any): ChallengeRegisterResponse {
    return ChallengeRegisterResponseFromJSONTyped(json, false);
}

export function ChallengeRegisterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeRegisterResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'membershipId': json['membershipId'],
        'acceptedTermsAt': json['acceptedTermsAt'],
        'realmLinked': json['realmLinked'],
    };
}

export function ChallengeRegisterResponseToJSON(json: any): ChallengeRegisterResponse {
    return ChallengeRegisterResponseToJSONTyped(json, false);
}

export function ChallengeRegisterResponseToJSONTyped(value?: ChallengeRegisterResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'membershipId': value['membershipId'],
        'acceptedTermsAt': value['acceptedTermsAt'],
        'realmLinked': value['realmLinked'],
    };
}

